import React, { useState } from "react";
import SiteLayout from "@/components/SiteLayout";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", mobile: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally { setLoading(false); }
  };

  return (
    <SiteLayout>
      <section className="mx-auto max-w-md px-6 py-16">
        <span className="overline">Create account</span>
        <h1 className="mt-2 font-display text-4xl font-bold text-[#0F2540]">Join Nirmal Hospital</h1>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
          <Inp label="Full name" v={form.name} s={(v) => setForm({ ...form, name: v })} required testid="r-name" />
          <Inp label="Email" type="email" v={form.email} s={(v) => setForm({ ...form, email: v })} required testid="r-email" />
          <Inp label="Mobile" v={form.mobile} s={(v) => setForm({ ...form, mobile: v })} testid="r-mobile" />
          <Inp label="Password" type="password" v={form.password} s={(v) => setForm({ ...form, password: v })} required testid="r-password" />
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="register-submit">
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#5C6B7A]">Already a member? <Link to="/login" className="text-[#1E4F87] font-semibold">Sign in</Link></p>
      </section>
    </SiteLayout>
  );
}

function Inp({ label, v, s, type = "text", required, testid }) {
  return (
    <div>
      <label className="text-sm font-medium text-[#0F2540]">{label}{required && " *"}</label>
      <input type={type} value={v} required={required} onChange={(e) => s(e.target.value)}
        className="mt-1 w-full rounded-xl border border-[#E1E8F0] bg-white px-4 py-2.5 outline-none focus:border-[#1E4F87]"
        data-testid={testid} />
    </div>
  );
}
